import {Pipe, PipeTransform} from "@angular/core";
import {format, parseISO} from "date-fns";
import { tz } from "@date-fns/tz";

@Pipe({
    name: 'formatDate',
    standalone: true
})
export class FormatDatePipe implements PipeTransform {

    transform(value: any, ...args: any[]): any {
        // console.log( args );
        // console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);
        let d = new Date(parseISO(value));
        // console.log ( value + " - " + format(d,"zzzz"));
        if ( args.length == 1 ) {
            return format(d,args[0]);
        }
        return format(d,'PPP');
    }

}
